import { createSlice } from "@reduxjs/toolkit";
import { profileAction } from "../action/profile";

const initialState = {
	user: null,
};

const profileReducer = createSlice({
	name: "profile",
	initialState,
	reducers: {},
	extraReducers: (build) => {
		build.addCase(profileAction.fulfilled, (state, action) => {
			state.user = action.payload;
		});
	},
});

export default profileReducer.reducer;
